import { render } from "./ClassModal.vue?vue&type=template&id=41c2d64a&ts=true"
import script from "./ClassModal.vue?vue&type=script&lang=ts"
export * from "./ClassModal.vue?vue&type=script&lang=ts"

import "./ClassModal.vue?vue&type=style&index=0&id=41c2d64a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__